var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayOutlined = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.624 3.351a.75.75 0 0 1 .748-.002l7 4a.75.75 0 0 1 0 1.302l-7 4A.75.75 0 0 1 3.25 12V4a.75.75 0 0 1 .374-.649zM4.75 5.292v5.416L9.488 8 4.75 5.292z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayOutlined);
export default ForwardRef;